import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { loginUser, logout } from '../store/slices/auth.slices';

type FieldType = {
  email?: string;
  password?: string;
  remember?: boolean;
};

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector((state: RootState) => state.auth.loading);

  const handleLogin = async (values: FieldType) => {
    try {
      await dispatch(loginUser({
        email: values.email || '',
        password: values.password || '',
      })).unwrap();
      const userTypeKey = localStorage.getItem('user_type_key');
      if (userTypeKey === 'BEP') {
        navigate('/quan-ly-bep', { replace: true });
      } else if (userTypeKey === 'BAN_HANG') {
        navigate('/banhang', { replace: true });
      } else {
        dispatch(logout());
        message.error('Tài khoản chưa được phân quyền vào ứng dụng bán hàng hoặc bếp');
      }
      if (userTypeKey === 'BEP' || userTypeKey === 'BAN_HANG') {
        message.success('Đăng nhập thành công');
      }
    } catch (error) {
      message.error(typeof error === 'string' ? error : 'Đăng nhập thất bại');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <Spin spinning={loading}>
          <Form
            name="login-form"
            layout="vertical"
            onFinish={handleLogin}
            initialValues={{ remember: true }}
            autoComplete="off"
          >
            <div className="login-header">
              <img className="login-logo" src="/image/logo-cuong-hoai.png" alt="Cường Hoài" />
              <h1>Đăng nhập</h1>
            </div>

            <Form.Item<FieldType>
              name="email"
              rules={[{ required: true, message: 'Vui lòng nhập email!' }]}
            >
              <Input
                prefix={<UserOutlined />}
                size="large"
                placeholder="Tên đăng nhập"
              />
            </Form.Item>

            <Form.Item<FieldType>
              name="password"
              rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                size="large"
                placeholder="Mật khẩu"
              />
            </Form.Item>

            <Form.Item<FieldType>
              name="remember"
              valuePropName="checked"
            >
              <Checkbox>Ghi nhớ đăng nhập</Checkbox>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" size="large" block>
                Login
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    </div>
  );
}
